import { getNetworkStatusCode } from 'lib/helpers/getNetworkStatusCode/getNetworkStatusCode'

/**
 * True when the server rejected the request as unauthenticated (HTTP 401) — an expired,
 * revoked, or otherwise rejected token. Accepts `unknown`, so call sites need no guard.
 *
 * The global Apollo error link already owns the outcome: it hard-navigates to `/login`.
 * That navigation does not unmount React synchronously, so every query in flight at
 * token-expiry still resolves with its 401 and still reaches consumers during the teardown
 * window. Use this to stay quiet for that window — the failure is handled and the page is
 * on its way out, so surfacing or reporting it adds nothing.
 *
 * Deliberately narrow: only 401. A 403 is an authorization failure the user stays on the
 * page for, and a 5xx is a real outage — both must keep reporting.
 */
export const isUnauthenticatedError = (error: unknown): boolean => getNetworkStatusCode(error) === 401
